if (!customElements.get('recommendation-card-grid')) {
  class RecommendationCardGrid extends HTMLElement {
    connectedCallback() {
      this.desktopQuery = window.matchMedia('(min-width: 990px)');
      this.resizeHandler = () => this.queueAlignment();

      window.addEventListener('resize', this.resizeHandler, { passive: true });

      if (this.desktopQuery.addEventListener) {
        this.desktopQuery.addEventListener('change', this.resizeHandler);
      } else if (this.desktopQuery.addListener) {
        this.desktopQuery.addListener(this.resizeHandler);
      }

      this.queueAlignment();

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.queueAlignment());
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.resizeHandler);

      if (this.desktopQuery) {
        if (this.desktopQuery.removeEventListener) {
          this.desktopQuery.removeEventListener('change', this.resizeHandler);
        } else if (this.desktopQuery.removeListener) {
          this.desktopQuery.removeListener(this.resizeHandler);
        }
      }

      if (this.alignmentFrame) {
        cancelAnimationFrame(this.alignmentFrame);
      }
    }

    queueAlignment() {
      if (this.alignmentFrame) {
        cancelAnimationFrame(this.alignmentFrame);
      }

      this.alignmentFrame = requestAnimationFrame(() => {
        this.alignmentFrame = null;
        this.alignRows();
      });
    }

    alignRows() {
      const grid = this.querySelector('.multicolumn-recommendations__grid');
      if (!grid) return;

      const cards = Array.from(grid.querySelectorAll(':scope > .multicolumn-recommendations__card'));
      if (!cards.length) return;

      this.resetHeights(cards);

      if (!this.desktopQuery.matches || this.dataset.alignRows === 'false') return;

      // Cards can wrap onto more than one visual row. Only equalise cards that
      // actually sit alongside one another so future layouts remain flexible.
      const visualRows = [];

      cards.forEach((card) => {
        const top = Math.round(card.getBoundingClientRect().top);
        let row = visualRows.find((candidate) => Math.abs(candidate.top - top) <= 2);

        if (!row) {
          row = { top, cards: [] };
          visualRows.push(row);
        }

        row.cards.push(card);
      });

      visualRows.forEach((row) => this.alignCardGroup(row.cards));
    }

    resetHeights(cards) {
      cards.forEach((card) => {
        const header = card.querySelector('.multicolumn-recommendations__card-header');
        if (header) header.style.minHeight = '';

        card.querySelectorAll('.multicolumn-recommendations__recommendation').forEach((item) => {
          item.style.minHeight = '';
        });
      });
    }

    alignCardGroup(cards) {
      if (cards.length < 2) return;

      const headers = cards
        .map((card) => card.querySelector('.multicolumn-recommendations__card-header'))
        .filter(Boolean);

      this.equaliseElements(headers);

      const recommendationLists = cards.map((card) =>
        Array.from(
          card.querySelectorAll(
            '.multicolumn-recommendations__items > .multicolumn-recommendations__recommendation'
          )
        )
      );

      const rowCount = Math.max(...recommendationLists.map((items) => items.length), 0);

      for (let index = 0; index < rowCount; index += 1) {
        const rowItems = recommendationLists
          .map((items) => items[index])
          .filter(Boolean);

        this.equaliseElements(rowItems);
      }
    }

    equaliseElements(elements) {
      if (elements.length < 2) return;

      const tallest = Math.max(
        ...elements.map((element) => Math.ceil(element.getBoundingClientRect().height))
      );

      elements.forEach((element) => {
        element.style.minHeight = `${tallest}px`;
      });
    }
  }

  customElements.define('recommendation-card-grid', RecommendationCardGrid);
}